import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AiFillPhone, AiFillMail, AiFillHome } from "react-icons/ai";
import { BiSolidChevronRight } from "react-icons/bi";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import ContactModal from "./ContactModal";
import SuccessModal from "./SuccessModal";
import { serviceCategories } from "../data/serviceData";
import { mailHref, phoneHref, siteConfig } from "../siteConfig";

const Footer = () => {
  const location = useLocation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      key: "linkedin",
      label: "LinkedIn",
      href: siteConfig.socialLinks.linkedin,
      icon: <FaLinkedinIn />,
    },
    {
      key: "facebook",
      label: "Facebook",
      href: siteConfig.socialLinks.facebook,
      icon: <FaFacebookF />,
    },
    {
      key: "instagram",
      label: "Instagram",
      href: siteConfig.socialLinks.instagram,
      icon: <FaInstagram />,
    },
  ];

  const handleEnquiryClick = () => {
    if (location.pathname === "/") {
      setIsContactModalOpen(true);
    }
  };

  return (
    <>
      {/* Enquiry Section */}
      <div className="py-5 bg-gradient-to-l from-blue-500 to-purple-900 text-white">
        <div className="container mx-auto text-center">
          <div className="flex flex-col lg:flex-row justify-center">
            <div className="w-full lg:w-8/12">
              <div className="flex items-center justify-center py-6">
                <p className="mb-0 text-center text-lg lg:text-xl xl:text-2xl font-semibold">
                  Looking for Calibration, Testing solutions?
                </p>
              </div>
            </div>
            <div className="w-full lg:w-4/12">
              <div className="flex items-center justify-center py-6">
                {location.pathname === "/" ? (
                  <button
                    type="button"
                    className="makean_enquiry"
                    onClick={handleEnquiryClick}
                  >
                    Make an Enquiry
                  </button>
                ) : (
                  <Link to="/contact">
                    <button type="button" className="makean_enquiry">
                      Make an Enquiry
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <footer className="bg-[#1A1D2B]">
        <div className="container mx-auto px-6 py-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Logo and Description */}
            <div className="space-y-4">
              <Link to="/" className="flex items-center space-x-2">
                <img src="/img/logo.png" alt="Logo" className="h-20" />
              </Link>
              <p className="text-gray-300 text-sm leading-relaxed">
                Recon Calibration & Test Labs LLP, your trusted partner for
                precision calibration solutions. At Recon calibration & Test Labs LLP, we understand the
                critical role that accurate calibration plays in ensuring the
                reliability and performance of your instruments.
              </p>
            </div>

            {/* Links Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-white font-bold">Quick Links</h3>
                <ul className="mt-4 space-y-3">
                  {[
                    { label: "Home", path: "/" },
                    { label: "About Us", path: "/about" },
                    { label: "Services", path: "/services" },
                    { label: "Contact Us", path: "/contact" },
                  ].map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="flex items-center text-gray-300 hover:text-white"
                      >
                        <BiSolidChevronRight className="mr-2" />
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="text-white font-bold">Services</h3>
                <ul className="mt-4 space-y-3">
                  {serviceCategories.map((service) => (
                    <li key={service.slug}>
                      <Link
                        to={`/services/${service.slug}`}
                        className="flex items-center text-gray-300 hover:text-white"
                      >
                        <BiSolidChevronRight className="mr-2" />
                        {service.shortName}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Contact Us Section */}
            <div>
              <h3 className="text-white font-bold">Contact Us</h3>
              <ul className="mt-4 space-y-4 text-gray-300">
                <li className="flex items-start">
                  <AiFillHome  className="mt-1 mr-2 text-4xl" />
                  Unit F1, Plot No. BG/PAP3, MIDC Chowk, Opp. to Fern Residency,
                  near Bharat gas, Bhosari Pune - 411026
                </li>
                <li className="flex items-center">
                  <AiFillPhone  className="mr-2 text-lg" />
                  <div className="flex flex-col gap-1">
                    <a href={phoneHref(siteConfig.phonePrimary)} className="hover:text-white">
                      {siteConfig.phoneDisplay[0]}
                    </a>
                    <a href={phoneHref(siteConfig.phoneSecondary)} className="hover:text-white">
                      {siteConfig.phoneDisplay[1]}
                    </a>
                  </div>
                </li>
                <li className="flex items-start">
                  <AiFillMail className="mr-2 mt-1 text-lg" />
                  <div>
                    <a href={mailHref()} className="hover:text-white">
                      {siteConfig.email}
                    </a>
                    <div className="mt-4 flex items-center gap-3">
                      {socialLinks.map((socialLink) =>
                        socialLink.href ? (
                          <a
                            key={socialLink.key}
                            href={socialLink.href}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={socialLink.label}
                            className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-gray-300 transition hover:bg-white/20 hover:text-white"
                          >
                            {socialLink.icon}
                          </a>
                        ) : (
                          <span
                            key={socialLink.key}
                            aria-label={`${socialLink.label} link coming soon`}
                            title={`${socialLink.label} link coming soon`}
                            className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-gray-300"
                          >
                            {socialLink.icon}
                          </span>
                        )
                      )}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="mt-8 border-t border-gray-500 pt-4">
            <p className="text-center text-sm text-gray-300">
              Copyright © {currentYear} Recon Calibration & Test
              Labs LLP. All rights
              reserved.
            </p>
          </div>
        </div>
      </footer>

      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        onSuccess={() => {
          setIsContactModalOpen(false);
          setIsSuccessOpen(true);
        }}
      />
      <SuccessModal
        isOpen={isSuccessOpen}
        onClose={() => setIsSuccessOpen(false)}
      />
    </>
  );
};

export default Footer;
